/**
 * Product card: variant select + Add to Basket (AJAX)
 * Works globally on any card that includes .wn-card-atc
 */
(function () {
  if (window.__wnCardVariantInit) return;
  window.__wnCardVariantInit = true;

  var MONEY_FORMAT =
    (window.theme && window.theme.moneyFormat) ||
    (window.Shopify && window.Shopify.money_format) ||
    'Rs. {{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, MONEY_FORMAT);
    }
    var amount = (Number(cents) / 100).toFixed(2);
    return 'Rs. ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function parseVariants(root) {
    var el = root.querySelector('[data-wn-variants-json]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function findVariant(variants, id) {
    var nid = Number(id);
    for (var i = 0; i < variants.length; i++) {
      if (Number(variants[i].id) === nid) return variants[i];
    }
    return null;
  }

  function updatePrice(card, variant) {
    if (!variant) return;
    var priceRoot =
      card.querySelector('[data-wn-price]') ||
      card.querySelector('.price');
    if (!priceRoot) return;

    var saleEl = priceRoot.querySelector('.price-item--sale, .price-item--regular');
    var compareEl = priceRoot.querySelector('.price-item--regular:not(.price-item--sale)');

    // Dawn often has sale + compare structure
    var priceItems = priceRoot.querySelectorAll('.price-item');
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceRoot.classList.add('price--on-sale');
      if (priceItems.length >= 2) {
        // typically first is regular/compare, second is sale — varies by theme
        var compareTarget = priceRoot.querySelector('s .price-item, .price__sale s .price-item, .price-item--regular');
        var saleTarget = priceRoot.querySelector('.price__sale .price-item--sale, .price-item--sale') || saleEl;
        if (saleTarget) saleTarget.textContent = variant.price_formatted || formatMoney(variant.price);
        if (compareTarget) compareTarget.textContent = variant.compare_at_formatted || formatMoney(variant.compare_at_price);
      } else if (saleEl) {
        saleEl.textContent = variant.price_formatted || formatMoney(variant.price);
      }
    } else {
      priceRoot.classList.remove('price--on-sale');
      if (saleEl) saleEl.textContent = variant.price_formatted || formatMoney(variant.price);
    }

    // Dedicated live price node if present
    var live = card.querySelector('[data-wn-live-price]');
    if (live) {
      live.innerHTML = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        live.innerHTML =
          '<span class="wn-live-compare"><s>' +
          (variant.compare_at_formatted || formatMoney(variant.compare_at_price)) +
          '</s></span> <span class="wn-live-sale">' +
          (variant.price_formatted || formatMoney(variant.price)) +
          '</span>';
      } else {
        live.textContent = variant.price_formatted || formatMoney(variant.price);
      }
    }
  }

  function updateButton(btn, variant) {
    if (!btn || !variant) return;
    btn.setAttribute('data-variant-id', String(variant.id));
    var label = btn.querySelector('[data-wn-add-label]');
    if (variant.available) {
      btn.disabled = false;
      if (label) label.textContent = 'ADD TO BASKET';
    } else {
      btn.disabled = true;
      if (label) label.textContent = 'SOLD OUT';
    }
  }

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function addToCart(variantId, btn) {
    btn.classList.add('is-loading');
    var prev = btn.querySelector('[data-wn-add-label]');
    var oldText = prev ? prev.textContent : '';
    if (prev) prev.textContent = 'ADDING…';

    var payload = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          if (typeof drawer.open === 'function') drawer.open();
          else {
            drawer.classList.add('active');
            document.body.classList.add('overflow-hidden');
          }
        } else {
          // Fallback: refresh bubble then go to cart
          return fetch(cartRoot() + '?sections=cart-icon-bubble')
            .then(function (r) {
              return r.json();
            })
            .then(function (sections) {
              var bubble = document.querySelector('#shopify-section-cart-icon-bubble, .shopify-section-cart-icon-bubble');
              if (bubble && sections['cart-icon-bubble']) {
                var tmp = document.createElement('div');
                tmp.innerHTML = sections['cart-icon-bubble'];
                var next = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
                if (next && bubble.parentNode) bubble.parentNode.replaceChild(next, bubble);
              }
              if (prev) prev.textContent = 'ADDED';
              setTimeout(function () {
                if (prev) prev.textContent = oldText || 'ADD TO BASKET';
              }, 1200);
            });
        }
        if (prev && !document.querySelector('cart-drawer')) {
          /* handled above */
        } else if (prev) {
          prev.textContent = 'ADD TO BASKET';
        }
      })
      .catch(function (err) {
        var msg =
          (err && (err.description || err.message)) ||
          'Could not add to cart';
        alert(msg);
        if (prev) prev.textContent = oldText || 'ADD TO BASKET';
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  }

  function bindCard(root) {
    if (root.dataset.wnBound === '1') return;
    root.dataset.wnBound = '1';

    var card = root.closest('.card-wrapper') || root.closest('.card') || root;
    var variants = parseVariants(root);
    var select = root.querySelector('[data-wn-variant-select]');
    var btn = root.querySelector('[data-wn-add-to-cart]');

    if (select) {
      select.addEventListener('change', function () {
        var variant = findVariant(variants, select.value);
        updatePrice(card, variant);
        updateButton(btn, variant);
      });
      // Sync initial selected
      var initial = findVariant(variants, select.value);
      if (initial) {
        updatePrice(card, initial);
        updateButton(btn, initial);
      }
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = btn.getAttribute('data-variant-id');
        if (!id || btn.disabled) return;
        addToCart(id, btn);
      });
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-wn-card-atc]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Theme editor / AJAX section reloads
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
